<template>
    <div>        
        <header class="header is-fixed vue-fixed-header vue-fixed-header--isFixed" role="Header">
            <div class="row align-items-center">
                <div class="col-xl-10 col-sm-9 col-8 logo">
                    <div class="d-flex align-items-center">
                        <router-link :to="logourl" class="hide-991"><img src="@/assets/images/svg/logo.svg" alt="zain-logo" class="zainLogo"></router-link>
                        <!-- <span class="section_title show-991">{{this.$route.meta.title}}</span> -->
                        <div class="head">
                            <p class="name">{{$t('topContent.name')}}</p>
                            <p class="title">{{$t('topContent.title')}}</p>
                            <p class="year">{{$t('topContent.year')}}</p>
                        </div>
                        <div class="module-title">
                            <span v-if="$i18n.locale=='en'">{{this.$route.meta.title}}</span>
                            <span v-if="$i18n.locale=='ar'">{{this.$route.meta.title_ar}}</span> 
                        </div>
                    </div>
                </div>
                <div class="col-xl-2 col-sm-3 col-4 menuIcon">
                    <div class="menu">
                        <div class="menuWrapper">
                            <langSwitch></langSwitch>
                                <svg class="separator" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13" width="6" height="13">
                                <path fill="white" d="M3.93 0L6 0L2.07 13L0 13L3.93 0Z" />
                            </svg>
                            <div class="menu-icon">
                                <a href="#" @click.prevent.stop="openMenu" class="menu">
                                    <menuIcon></menuIcon>
                                </a>
                            </div>
                        </div>
                        <!-- <a href="#" @click.prevent.stop="openMenu">Table of Contents 
                            <span>
                                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="40" height="30.692" viewBox="0 0 40 30.692">
                                    <use xlink:href="#menu-icon"></use>
                                </svg>
                            </span>
                        </a> -->
                    </div>
                </div>
            </div>
        </header>
        <reportMenu ref="menu"></reportMenu>
    </div>   
</template>
<script>
import reportMenu from "@/common/reportMenu.vue";
import langSwitch from "@/common/layout/partials/languageSwitch.vue";
import menuIcon from "@/common/layout/partials/menuIcon.vue";
export default {
    // props:{
    //     sectionTitle: String
    // },
    components:{
        reportMenu,
        langSwitch,
        menuIcon
    },
    data(){
        return{
            meuOpen: false,
            logourl:''
        }
    },
    methods:{
        openMenu: function(e){
            var m = document.querySelector(".tableContents");
            this.$refs.menu.toggleMenu();
        }
    },
    created(){
      if(this.$i18n.locale=="en"){
            this.logourl = '/en'
        }
        else{
             this.logourl = '/ar'
        }
    }
    
}
</script>
<style lang="scss" scoped>
header{
    position: fixed;
    width: 100%;
    left: 0;
    top: rem(30px);
    padding: 0px rem(50px);
    z-index:99;
    transition: all 0.5s ease;
    height: 76px;
    display: flex;
    align-items: center;
    & > .row{
        width: 100%;
    }
    .head{
        padding:0 rem(36px);
        @media screen and (max-width:1200px) and (min-width:992px){
            padding:0 rem(20px);
        }
        @media screen and (max-width:991px){
            display:none;
        }
        p{
            color:var(--white);
            font-size:rem(18px);
            font-weight:600;
            line-height:1;
            margin-bottom:0;
            @media screen and (max-width:1200px) and (min-width:992px){
                font-size:rem(14px);
            }
            &.title{
                margin:4px 0;
                font-weight:900;
            }
            &.year{
                color:var(--yellow);
                font-weight:900;
            }
        }
        @media screen and (max-width:767px){
            p{
                font-size:rem(15px);
            }
        }
    }
    @media screen and (max-width:1600px){
        padding: 0 15px;
        top:rem(16px);
    }
    @media screen and (max-width: 1200px){
        padding-right: rem(40px);
    }
    @media screen and (max-width: 991px){
        padding-right: rem(35px);
        .menuIcon{
            padding-right:0 !important; 
        }
    }
    @media screen and (max-width:575px){
        padding-right:0;
    }
    .menu{
        color:#fff;
        text-align: right;
        font-size: rem(20px);
        @media screen and (max-width:414px){
            font-size:rem(15px);
        }
        a{
            color:#fff;
            &:hover{
                text-decoration: none;
                opacity: 0.5;
            }
        }
        svg{
            width: 40px;
            fill:#fff;
            height: auto;
            margin-left: rem(30px);
            @media screen and (max-width:575px){
                width:25px;
                margin-left:rem(16px);
            }
        }
        /deep/ .menuWrapper{
            justify-content: flex-end;
            // @media screen and (max-width:1100px) and (min-width:992px){
            //     flex-wrap:nowrap;
            // }
            // @media screen and (max-width: 1200px){
            //     margin-right: 20px;
            //     margin-top: 15px;
            // }
        }
    }
    .logo{
        img{
            max-width:140px;
            @media screen and (max-width:1199px){
                max-width:100px;
            }
        }
        .module-title{
            color:#fff;
            font-size: rem(18px);
            font-weight:700;
            text-transform: uppercase;
            line-height:1.3;
            position:relative;
            &:before{
                content:"";
                position:absolute;
                height:60px;
                width:2px;
                background:#fff;
                left:-17px;
                top:50%;
                transform:translateY(-50%);
                border-radius: 20px;
            }
            @media screen and (max-width:1199px) and (min-width:992px){
                font-size: rem(15px);
                &:before{
                    left:-10px;
                }
            }
            @media screen and (max-width:991px){
                &:before{
                    display:none;
                }
            }
            @media screen and (max-width:575px){
                font-size:rem(16px);
            }
        }
    }
    &.vue-fixed-header--isFixed{
        top: 0px;
        background: rgba(0,0,0,0.4);
        padding-top: rem(0px);
        padding-bottom: rem(0px);

        .menuWrapper{
            /deep/{
                .separator{
                    width: 7px;
                    // margin: 0 23px 0 13px;
                    margin: 0 15px 0 6px;
                }
                .menu-icon{
                    width: rem(45px);
                    height: rem(45px);
                    img{
                        max-width: 20px;
                    }
                }
                .pulse-wrapper {
                    width: rem(65px);
                    height: rem(65px);
                }
            }
        }
        
    }
    .menuIcon{
        padding-right:rem(0px);
    }
    .section_title{
        color:#fff;
        display: block;
        text-transform:uppercase;
        line-height:1.3;
        @media screen and (max-width:575px){
            font-size:rem(15px);
        }
        
    }
    @media screen and (min-width: 992px){
        .show-991{
            display: none !important;
        }
    }
    @media screen and (max-width: 991px){
        .hide-991{
            display: none !important;
        }
    }
    @media only screen 
    and (device-width: 390px) 
    and (device-height: 844px) 
    and (-webkit-device-pixel-ratio: 3) { 
        .show-991{
            display: block !important;
        }
        .hide-991{
            display: none !important;
        }
    }
    @media only screen 
    and (device-width: 428px) 
    and (device-height: 926px) 
    and (-webkit-device-pixel-ratio: 3) { 
        .show-991{
            display: block !important;
        }
        .hide-991{
            display: none !important;
        }
    }
}
.light-Slide{
    header {
        .menu{
            a{
                color:#000;
            }
            svg{
                fill:#000;
            }
        }
    }
}

// arabic
[lang="ar"] {
    header{
        right: 0; left: auto;
        padding-left: rem(50px); padding-right: rem(50px);
        @media screen and (max-width:1600px){
            padding-left: 15px; padding-right: 15px;
            
        }
        @media screen and (max-width: 1200px){
            padding-left: rem(40px);
            padding-right: 15px;
        }
        @media screen and (max-width: 991px){
            padding-left: rem(35px);
            .menuIcon{
                padding-left:0 !important; 
            }
        }
        @media screen and (max-width:575px){
            padding-left:0;
        }
        .head{
            p{
                &.title{
                    margin:6px 0;
                }

            }
        }
        .menu{
            text-align: left;
            svg{
                margin-right: rem(30px); margin-left: 0;
                @media screen and (max-width:575px){
                    
                    margin-right:rem(16px); margin-left: 0;
                }
            }
        }
        &.vue-fixed-header--isFixed{
            .menuWrapper{
                /deep/{
                    .separator{
                        // margin-right: 13px; margin-left: 23px;
                        margin-right: 6px; margin-left: 15px;
                    }
                   
                }
            }
        }
        .menuIcon{
            padding-left:rem(35px);
            padding-right: 0;
        }
        .logo{
            .module-title{
                &:before{
                    right:-22px;
                    left:auto;
                }
                @media screen and (max-width:1199px) and (min-width:992px){
                    &:before{
                        right:-12px;
                        left:auto;
                    }
                }
            }
        }
    }
}
</style>